import { library, IconDefinition } from '@fortawesome/fontawesome-svg-core'

export default function addFontAwesomeIcon(...icons: IconDefinition[]) {
	library.add(...icons)
}
